import React from "react";
import "./cit-dashboard.styles.css";
import { Component } from "react";

import API from "../../api";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectUserData } from "../../redux/user/user.selectors";
import { message, Row, Col, PageHeader, Select, List } from "antd";
import {
  setPowerbiData,
  setScreen,
} from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.actions";
import { selectCitData } from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.selectors";

/**
 *
 * @classdesc The Buying reccomendation tab component.
 * @description Displays a table containing the daily output from the modal
 * @component
 */
class CITCommodityList extends Component {
  state = {
    isSpinnerOnTable: true,
    powerbiLinks: [],
  };

  /**
   * @function
   * @description Wait until the user logs in so that a valid access token is generated
   * to call the get api for daily recommentation data.
   * @memberof DownloadReport
   */
  waitUntilLogin = () => {
    if (localStorage.getItem("accessToken") != null) {
      this.setState({ isSpinnerOnTable: true });
      API.get("/powerbi-links", {
        params: { crop_id: this.props.citData.crop_id },
      }).then((response) => {
        this.props.setPowerbiData([]);
        this.setState({
          powerbiLinks: response.data.data,
        });
      });
      this.setState({
        isSpinnerOnTable: false,
      });
    } else {
      setTimeout(() => this.waitUntilLogin(), 100);
    }
  };

  componentDidMount() {
    this.waitUntilLogin();
  }

  render() {
    const ConfigOptions = {
      maxCount: 1,
    };
    message.config(ConfigOptions);
    const data = [
      {
        id: 1,
        crop_id: "123",
        name: "Power BI Report",
        link: "https://example.com/powerbi/report",
        description: "This is a Power BI report.",
        is_active: true,
        created_by: "admin",
        created_at: "2024-10-01T12:34:56",
        updated_at: "2024-10-01T12:34:56",
      },
      {
        id: 2,
        crop_id: "456",
        name: "Power BI Dashboard",
        link: "https://example.com/powerbi/dashboard",
        description: "This is a Power BI dashboard.",
        is_active: true,
        created_by: "user1",
        created_at: "2024-10-02T09:30:00",
        updated_at: "2024-10-02T09:30:00",
      },
    ];
    //#endregion
    const handleChange = (pagination, filters, sorter) => {
      // this.setState({ filteredInfo: filters });
    };
    return (
      <div
        className="cit-container"
        style={{ height: window.innerHeight - 130 }}
      >
        <div className="dashboard">
          <PageHeader
            onBack={() => this.props.setScreen(0)}
            title={this.props.citData.crop_name}
            className="cit-header"
            style={{
              background: "#4672ba",
            }}
          />
          <Row>
            <Col style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <List
                // header={<div>Header</div>}
                // footer={<div>Footer</div>}
                // bordered
                size="large"
                dataSource={this.state.powerbiLinks}
                itemLayout="horizontal"
                renderItem={(item) => (
                  <List.Item
                    onClick={() => {
                      this.props.setPowerbiData(item);
                      this.props.setScreen(2);
                    }}
                    style={{ background: "white", paddingLeft: "16px" }}
                  >
                    <List.Item.Meta
                      title={item.name}
                      description={item.description}
                    />
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  citData: selectCitData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setScreen: (data) => dispatch(setScreen(data)),
    setPowerbiData: (data) => dispatch(setPowerbiData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CITCommodityList);
